import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function PriceStructureSection() {
  return (
    <section id="price-structure" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.priceStructure.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.priceStructure.title}
          </h2>
        </div>

        {/* Flow diagram */}
        <div className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8 md:mb-10">
          {pricingData.priceStructure.items.map((item, idx) => (
            <div
              key={item.num}
              className="relative bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              {/* Connector arrows for desktop */}
              {idx < 3 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-6 h-6">
                  <i className="ri-arrow-right-s-line text-lg text-primary-300" />
                </div>
              )}

              <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                <span className="text-xs md:text-sm font-bold text-primary-600 font-heading">
                  {item.num}
                </span>
              </div>

              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.desc}
              </p>

              {item.services.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {item.services.map((s) => (
                    <span
                      key={s}
                      className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-primary-50 text-primary-700 border border-primary-200/50"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Flow arrows for mobile */}
        <div className="reveal flex lg:hidden justify-center gap-6 mb-8">
          <i className="ri-arrow-down-line text-primary-300 text-xl" />
          <i className="ri-arrow-down-line text-primary-300 text-xl" />
          <i className="ri-arrow-down-line text-primary-300 text-xl" />
        </div>

        {/* Note */}
        <div className="reveal text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-background-100 border border-background-200/70">
            <i className="ri-information-line text-primary-500" />
            <p className="text-sm text-foreground-600">
              {pricingData.priceStructure.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}